import React, { useState, useEffect, useContext } from 'react';
import './invoice.css';
import { InvoiceContext } from '../../context/invoiceContext/InvoiceContext';
import { useParams, useNavigate } from 'react-router-dom';
import { addMovementInvoice } from '../../context/movementContext/apiCalls';
import PaginationComponent from '../../components/paginationComponent/PaginationComponent';
import TableComponent from '../../components/tableComponent/TableComponent';
import LoadingComponent from '../../components/loadingComponent/LoadingComponent';
import PageSizeComponent from '../../components/pageSizeComponent/PageSizeComponent';
import FilterDateInput from '../../components/filterDateInput/FilterDateInput';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent';
import ErrorComponent from '../../components/errorComponent/ErrorComponent';
import AdminSideBar from '../../components/adminSideBar/AdminSideBar';
import FilterInput from '../../components/filterInput/FilterInput';
import SubLoadingComponent from '../../components/subLoadingComponent/SubLoadingComponent';
import { EntrepriseContext } from '../../context/entrepriseContext/EntrepriseContext';
import { deleteInvoice, getInvoices } from '../../context/invoiceContext/apiCalls';
import { getEntreprisesMini } from '../../context/entrepriseContext/apiCalls';
import ModalComponent from '../../components/modalComponent/ModalComponent';
import FilterMonthInput from '../../components/filterMonthInput/FilterMonthInput';
import { MovementContext } from '../../context/movementContext/MovementContext';
import FormInput from '../../components/formInput/FormInput';
import FormTextArea from '../../components/formTextArea/FormTextArea';
import ImageLoader from '../../components/imageLoader/ImageLoader';

function Invoice() {
    const { dispatch, invoices, isFetching, error, count: pages, isFetchingDelete, errorDelete, message } = useContext(InvoiceContext);
    const { dispatch: dispatchEntreprise, entreprisesMini } = useContext(EntrepriseContext);

    const { page = 1 } = useParams();
    const navigate = useNavigate();
    const [pageSize, setPageSize] = useState(10);

    const [id, setId] = useState("");
    const [entreprise, setEntreprise] = useState({ nom: "Choisir Entreprise", id: 0, });
    const [dateApplyInvoice, setDateApplyInvoice] = useState("");
    const [dateCreationInvoice, setDateCreationInvoice] = useState("");

    useEffect(() => {
        getInvoices(dispatch, pageSize, page, id, entreprise.id, dateApplyInvoice, dateCreationInvoice);
    }, [dispatch, pageSize, page, id, entreprise, dateApplyInvoice, dateCreationInvoice])

    useEffect(() => {
        navigate(`/invoices/1`);
    }, [id, entreprise, dateApplyInvoice, dateCreationInvoice])

    useEffect(() => {
        dispatch({
            type: "CLEAR_INVOICE",
        })
        getEntreprisesMini(dispatchEntreprise);
    }, [])

    /**************  Ajouter Modal  **************/
    const [modalAddActive, setModalAddActive] = useState(false);
    const [addIdInvoice, setAddIdInvoice] = useState("");
    const [addEntreprise, setAddEntreprise] = useState({ nom: "Choisir Entreprise", id: 0, });
    const [addType, setAddType] = useState({ nom: "Décharge", id: 1 },)
    const [addMontant, setAddMontant] = useState("0");
    const [addMotif, setAddMotif] = useState("");
    const [addInvoiceMonth, setAddInvoiceMonth] = useState("");
    const [addFileEncaisse, setAddFileEncaisse] = useState(null);
    const [addErrorBox, setAddErrorBox] = useState("");
    const { dispatch: dispatchMovement, movement, errorAdd: errorAddMovement, isFetchingAdd: isFetchingAddMovement } = useContext(MovementContext);

    useEffect(() => {
        if (Object.keys(movement).length !== 0) {
            dispatchMovement({
                type: "CLEAR_MOVEMENT",
            })
            setAddFileEncaisse(null)
            navigate(`/movements/1`);
        }
    }, [movement])

    useEffect(() => {
        if (errorAddMovement != false) {
            setAddErrorBox(errorAddMovement);
            setModalAddActive(true);
        }
    }, [errorAddMovement])

    const updateModalUpdateActive = (id, entreprise, montant, invoiceMonth) => {
        setModalAddActive(true);
        setAddIdInvoice(id);
        setAddInvoiceMonth(invoiceMonth);
        setAddEntreprise(entreprisesMini.filter(item => item.id === entreprise)[0]);
        setAddMontant(montant);
    }

    const handleAddAction = () => {
        addMovementInvoice(dispatchMovement, addMontant, addIdInvoice, addMotif, addFileEncaisse);
    }

    /**************  Delete Modal  **************/
    const [modalDeleteActive, setModalDeleteActive] = useState(false);
    const [deleteIdInvoice, setDeleteIdInvoice] = useState("");
    const [deleteErrorBox, setDeleteErrorBox] = useState("");

    const deleteModalDeleteActive = (id) => {
        setModalDeleteActive(true);
        setDeleteIdInvoice(id);
    }

    useEffect(() => {
        if (errorDelete != false) {
            setDeleteErrorBox(errorDelete);
            setModalDeleteActive(true);
        }
    }, [errorDelete])

    useEffect(() => {
        if (message !== "") {
            dispatchMovement({
                type: "CLEAR_INVOICE",
            })
            setModalDeleteActive(false);
            getInvoices(dispatch, pageSize, page, id, entreprise.id, dateApplyInvoice, dateCreationInvoice);
        }
    }, [message])

    const deleteInvoiceHandler = () => {
        deleteInvoice(dispatch, deleteIdInvoice);
    }

    return (
        <div className='container-global'>
            <AdminSideBar activeTab="invoice" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>Factures :</span>
                </div>

                {
                    error ? <ErrorComponent error={error} /> : (
                        <>
                            <div className="filter">
                                <span className="adv-research">Recherche Avancée</span>
                                <div className="filter-content">
                                    <FilterInput placeholder={'ID'} setItem={setId} />
                                    <DropDownComponent data={[{ nom: "Choisir Entreprise", id: 0, }, ...entreprisesMini]} itemChoisir={entreprise} setItemChoisir={setEntreprise} filter />

                                    <FilterMonthInput placeholder={"Date Application"} item={dateApplyInvoice} setItem={setDateApplyInvoice} />
                                    <FilterDateInput placeholder={"Date Creation"} item={dateCreationInvoice} setItem={setDateCreationInvoice} />
                                </div>
                            </div>

                            <div className="add-item">
                                <span className='color-1' onClick={() => navigate(`/invoices/create`)}>Ajouter Facture</span>
                            </div>

                            {
                                isFetching ? <LoadingComponent /> : (
                                    invoices.length === 0 ? <span className='no-data'>Il n'y a pas encore de données</span>
                                        : (
                                            <>
                                                <PageSizeComponent pageSize={pageSize} setPageSize={setPageSize} itemLocation='invoices' />
                                                <div className="content">
                                                    {
                                                        <>
                                                            <TableComponent headers={['Id', 'Entreprise', 'Montant', 'Date Application', 'Date Creation', 'Action']}>
                                                                {
                                                                    invoices.map((invoice, index) => (
                                                                        <tr key={index}>
                                                                            <td>{invoice.id}</td>
                                                                            <td>{invoice.Entreprise ? invoice.Entreprise.nom : ""} </td>
                                                                            <td>{Number.parseFloat(invoice.montant).toFixed(2)}</td>
                                                                            <td>{invoice.invoiceMonth ? invoice.invoiceMonth : ""} </td>
                                                                            <td>{invoice.createdAt.slice(0, 10)}</td>
                                                                            <td>
                                                                                <span className='update' onClick={() => navigate(`/invoices/${invoice.id}/detail/1`)}>Detail</span>
                                                                                {
                                                                                    !(invoice.Movement) && (
                                                                                        <>
                                                                                            <span className='detail' onClick={() => updateModalUpdateActive(invoice.id, invoice.EntrepriseId, Number.parseFloat(invoice.montant).toFixed(2), invoice.invoiceMonth)}>Décharge</span>
                                                                                            <span className='update' onClick={() => deleteModalDeleteActive(invoice.id)}>Supprimer</span>
                                                                                        </>
                                                                                    )
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </TableComponent>
                                                            {
                                                                (pages > 1) && (<PaginationComponent page={page} pages={pages} item='invoices' />)
                                                            }
                                                        </>
                                                    }
                                                </div>
                                            </>
                                        )
                                )
                            }
                        </>
                    )
                }
            </div>

            <ModalComponent modalActive={modalAddActive} setModalActive={setModalAddActive} setErrorBox={setAddErrorBox} title="Décharge">
                {
                    isFetchingAddMovement ? <SubLoadingComponent /> : (
                        <form>
                            {addErrorBox !== "" && (<div className='box-error'>{addErrorBox}</div>)}
                            <div className='side-to-side'>
                                <DropDownComponent data={[addType]} itemChoisir={addType} setItemChoisir={setAddType} filter />
                                <DropDownComponent data={[addEntreprise]} itemChoisir={addEntreprise} setItemChoisir={setAddEntreprise} filter />
                            </div>
                            <div className='side-to-side'>
                                <FilterMonthInput placeholder={"Date Application"} item={addInvoiceMonth} setItem={setAddInvoiceMonth} inactive />
                                <FormInput label='Montant' itemInput={addMontant} setItemInput={setAddMontant} istype='number' auth inactive />
                            </div>
                            <FormTextArea label='Motif' itemInput={addMotif} setItemInput={setAddMotif} auth />
                            <ImageLoader imageLabel={"Attacher Image"} fileDecharge={addFileEncaisse} setFileDecharge={setAddFileEncaisse} imgWidth={"350px"} imgHeight={"300px"} />
                            <div className='button' onClick={handleAddAction}>
                                <span>Valider</span>
                            </div>
                        </form>
                    )
                }
            </ModalComponent>
            <ModalComponent modalActive={modalDeleteActive} setModalActive={setModalDeleteActive} setErrorBox={setDeleteErrorBox} title="Supprimer Facture">
                {
                    isFetchingDelete ? <SubLoadingComponent /> : (
                        <form>
                            {deleteErrorBox !== "" && (<div className='box-error'>{deleteErrorBox}</div>)}
                            <p>Êtes-vous sûr de vouloir supprimer cette facture ?</p>
                            <div className='button' onClick={deleteInvoiceHandler}>
                                <span>Valider</span>
                            </div>
                        </form>
                    )
                }
            </ModalComponent>

        </div>
    )
}

export default Invoice
